import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { ProtectedRoute } from './auth/ProtectedRoute';
import HomePage from './pages/Home';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import DashboardPage from './pages/Dashboard';
import ProfilePage from './pages/Profile';
import AdminDashboardPage from './pages/AdminDashboard';
import NotFoundPage from './pages/NotFound';
import ContestsPage from './pages/Contests';
import ContestDetailPage from './pages/ContestDetail';
import ContestPlayPage from './pages/ContestPlay';
import ContestResultsPage from './pages/ContestResults';
import MyEntriesPage from './pages/MyEntries';
import LegalPage from './pages/Legal';
import { PRIVACY_POLICY, TERMS_AND_CONDITIONS } from './legal/content';
import AdminContestsPage from './pages/admin/AdminContests';
import AdminCryptoPage from './pages/admin/AdminCrypto';
import AdminFinancePage from './pages/admin/AdminFinance';

/**
 * ITA6 client routes.
 *
 * Guards here are convenience only: every API call is authorized again in the
 * Worker, so a route that is reachable in the browser still returns nothing the
 * caller is not entitled to.
 */
export default function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        <Route path="/contests" element={<ContestsPage />} />
        <Route path="/contests/:id" element={<ContestDetailPage />} />
        <Route path="/contests/:id/results" element={<ContestResultsPage />} />
        {/* Public legal pages: indexable, no session required. */}
        <Route path="/privacy" element={<LegalPage document={PRIVACY_POLICY} />} />
        <Route path="/terms" element={<LegalPage document={TERMS_AND_CONDITIONS} />} />
        <Route
          path="/contests/:id/play"
          element={
            <ProtectedRoute>
              <ContestPlayPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-entries"
          element={
            <ProtectedRoute>
              <MyEntriesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/contests"
          element={
            <ProtectedRoute requireAdmin>
              <AdminContestsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/contests/:id"
          element={
            <ProtectedRoute requireAdmin>
              <AdminContestsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/finance"
          element={
            <ProtectedRoute requireAdmin>
              <AdminFinancePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/crypto"
          element={
            <ProtectedRoute requireAdmin>
              <AdminCryptoPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
